import React from "react";
import { useIntl } from "react-intl";
import NoData from "./NoData";

const NoPhysicalRoomsData = ({ children, data }) => {
  const intl = useIntl();

  return (
    <NoData
      data={data}
      message={intl.formatMessage({
        id: "Shared.NoPhysicalRoomsData.NoPhysicalRooms",
        defaultMessage: "There are no rooms. Please check later for new contents..."
      })}
    >
      {children}
    </NoData>
  );
};

export default NoPhysicalRoomsData;
